import { createFileRoute } from "@tanstack/react-router";

import { DcmpBillingDashboard } from "../tools/dashboards/DcmpBillingDashboard";

function DcmpBillingRoute() {
  return <DcmpBillingDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/dcmp-billing")({
  component: DcmpBillingRoute,
});
